import { defineComponent as _defineComponent } from 'vue'
import Vue, { PropType } from 'vue';
import Reservation from '@/model/Reservation';
import { contrastForColor } from '@/services/color-utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationChips',
  props: {
  reservation: { type: Object as PropType<Reservation>, required: true },
  compact: { type: Boolean, required: false, default: false },
  noLabel: { type: Boolean, required: false, default: false },
  noService: { type: Boolean, required: false, default: false },
  noAttachments: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;




return { __sfc: true,props, contrastForColor }
}

})